import axios from "axios";
import { baseUrl } from "../util";

export const getProductSummary = ({ id, business, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/ardash/" + id + "/product-summary",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business_id: business,
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};
